import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {PaymentTypeService} from 'app/blocks/service/api/payment-type.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IPaymentType} from 'app/blocks/model/payment-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {PaymentType} from 'app/blocks/model/payment-type.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class PaymentTypeResource extends AbstractEntityResource<IPaymentType> {
    constructor(paymentTypeService: PaymentTypeService, router: Router) {
        super(
            Resource.PAYMENT_TYPES,
            paymentTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.PAYMENT_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.PAYMENT_TYPES),
            (entity?) => new PaymentType(entity),
            (entity) => entity.code,
            'style'
        );
    }
}
